module.exports = __webpack_public_path__ + "static/media/reflective-listening@3x.d424d144.png";